import { WsRequestManager } from '@gem/modules/wsClient/wsManagers';

import { UnauthorizedWsCallsApiController } from './UnauthorizedWsCallsApiController';
import { UnauthorizedWsCallsApiNetworkService } from './UnauthorizedWsCallsApiNetworkService';
import { UnauthorizedWsCallsLog } from './UnauthorizedWsCallsLog';

export let unauthorizedWsCallsApiNetworkService: UnauthorizedWsCallsApiNetworkService | null = null;
export let unauthorizedWsCallsRequestManager: WsRequestManager | null = null;

let isApiInitiated = false;
export let unauthorizedWsCallsLog: UnauthorizedWsCallsLog | null = null;

export let unauthorizedWsCallsApiController: UnauthorizedWsCallsApiController | null;

export function initUnauthorizedCallsApi(wsCallsUrl: string): void {
  if (isApiInitiated) {
    return;
  }

  unauthorizedWsCallsApiNetworkService = new UnauthorizedWsCallsApiNetworkService();
  unauthorizedWsCallsRequestManager = new WsRequestManager(unauthorizedWsCallsApiNetworkService);
  unauthorizedWsCallsLog = new UnauthorizedWsCallsLog(unauthorizedWsCallsApiNetworkService);
  unauthorizedWsCallsApiController = new UnauthorizedWsCallsApiController(
    unauthorizedWsCallsApiNetworkService,
    wsCallsUrl
  );
  isApiInitiated = true;
}

export function disposeUnauthorizedCallsApi(): void {
  isApiInitiated = false;
  unauthorizedWsCallsApiNetworkService = null;
  unauthorizedWsCallsRequestManager = null;
  unauthorizedWsCallsLog = null;
  unauthorizedWsCallsApiController = null;
}
